<template>
  <v-app id="app">
    <NavBar />
    <v-main>
      <v-container fluid fill-height>
        <v-slide-y-transition mode="out-in">
          <router-view />
        </v-slide-y-transition>
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";
import NavBar from "./components/layout/NavBar";
import Footer from "./components/layout/Footer";
export default {
  name: "App",
  data() {
    return {};
  },
  components: {
    NavBar,
    Footer,
  },
  created() {
    this.autoLogin();
    this.getGrupos(this.token);
    this.getCoches(this.token);
    this.getImages(this.token)
    this.getClientes(this.token);
    this.getTareas(this.token);
    this.getReservas(this.token);
    this.getExtras(this.token);
    this.getPreciosExtras(this.token);
  },
  methods: {
    ...mapActions("usuarioNamespace", ["autoLogin", "getUsuarios"]),
    ...mapActions("grupoNamespace", ["getGrupos"]),
    ...mapActions("cocheNamespace", ["getCoches", "getImages"]),
    ...mapActions("clienteNamespace", ["getClientes"]),
    ...mapActions("tareaNamespace", ["getTareas"]),
    ...mapActions("reservaNamespace", ["getReservas"]),
    ...mapActions("extraNamespace", ["getExtras"]),
    ...mapActions("precioExtraNamespace", ["getPreciosExtras"]),
  },
  computed: {
    ...mapState("usuarioNamespace", ["token", "usuario"]),
  },
};
</script>
